import config from '../config';

/** Fired on window whenever the session ends outside the ApplicationProvider (MSAL events). */
export const SESSION_ENDED_EVENT = 'sp-session-ended';

/**
 * Ask the API to revoke the caller's tokens and clear the HttpOnly session cookie.
 * The cookie cannot be removed from JavaScript (VAPT-003), so the server must do it.
 * Never throws: local state must be cleared even when the request fails.
 */
export const endSessionOnServer = async (): Promise<void> => {
  try {
    await fetch(`${config.api.baseUrl}/users/logout`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: '{}',
    });
  } catch (e) {
    // ignore - the cookie expires on its own and tokenVersion is bumped on next successful logout
  }
  window.dispatchEvent(new Event(SESSION_ENDED_EVENT));
};
